<template>
  <div class="bg-slate-700 text-slate-200">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style></style>
